module.exports = __webpack_public_path__ + "static/media/telegram.ca6becc2.svg";